<template>
  <div class="description-list" :class="`description-list-${type}`">
    <slot></slot>
  </div>
</template>
<script>
// thin, thick
export default {
  props: {
    type: {
      type: String,
      default: "thick"
    }
  }
};
</script>
<style lang="less">
.description-list-large {
  font-size: 16px;
  line-height: 32px;
}
.description-list {
  padding: 0 30px;
  display: block;
  &-large {
    .description-list-item {
      &-term::after {
        content: ":";
      }
      &-term {
        width: 6em;
        line-height: 48px;
        flex: none;
      }
      &-content {
        flex: 1;
        line-height: 48px;
      }
    }
  }
  &-thin {
    .description-list-item {
      &-term::after {
        content: ":";
      }
      &-term {
        width: 6em;
        flex: none;
      }
      &-content {
        flex: 1;
      }
    }
  }
  &-thick {
    .description-list-item {
      // padding: 10px;
      justify-content: space-between;
      line-height: 60px;
      &-content {
        color: #262626;
      }
      &-term {
        width: 8em;
      }
    }
  }
  .description-list-item {
    display: flex;
    color: #525252;
    font-size: 14px;
  }
  &-content {
    color: #262626;
  }
}
</style>
